import { LatLng } from '@/types/google/geometry';

interface IpApiResponse {
  ip: string;
  city: string;
  region: string;
  country: string;
  country_name: string;
  postal: string;
  latitude: number;
  longitude: number;
  timezone: string;
  utc_offset: string;
  error?: boolean;
  reason?: string;
}

export const getLocationFromIpApi = async (): Promise<LatLng> => {
  try {
    const response = await fetch('https://ipapi.co/json/', {
      headers: {
        'User-Agent': 'paire-app/1.0'
      }
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data: IpApiResponse = await response.json();
    
    if (data.error) {
      throw new Error(`IP API error: ${data.reason || 'Unknown error'}`);
    }

    if (!data.latitude || !data.longitude) {
      throw new Error('Invalid coordinates received from IP API');
    }

    console.log(`Location detected via IP API: ${data.city}, ${data.region}, ${data.country_name}`);
    
    return {
      lat: data.latitude,
      lng: data.longitude
    };
  } catch (error) {
    console.error('IP API location fetch failed:', error);
    throw error;
  }
};